import axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import Notifications from '../components/Notifications';

const http = axios.create({
  baseURL: process.env.API_URL,
});
http.interceptors.request.use(request => {
  request.headers['Authorization'] = 'Bearer ' + window.localStorage.getItem('access-token');
  return request;
});

http.interceptors.response.use(response => {
  return response;
}, error => {
  if (/*error.response.status === 404 || */error.response.status >= 500) {
    /*if (error.response.data.message !== "Refresh Token not found") {*/
      Notifications.error(error.response.data.message);
    /*}*/
  }
  if (error.response.status === 401 || error.response.status === 403) {
    return Promise.reject(error);
  }
  return Promise.reject(error.response);
});

http.defaults.headers.common['Application'] = process.env.APPLICATION_ID;
http.defaults.headers.common['Instance-Id'] = 'web';
http.defaults.headers.post['Content-Type'] = 'application/json';

const refreshAccessToken = async () => {
  let count = 0;
  while (count < 3) {
    try {
      return await fetch(process.env.API_URL + 'v1/user/update-access-token', {
        method: 'POST',
        body: JSON.stringify({refresh_token: window.localStorage.getItem('refresh-token')}),
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          'Application': process.env.APPLICATION_ID,
          'Instance-Id': 'web'
        },
      }).then(response => {
        if (response.status !== 200) {
          throw new Error('');
        }
        return response.json();
      });
    } catch (error) {
      count++;
      refreshAccessToken();
    }
  }
  window.location.href = '/logout';
}

const refreshAuthLogic = failedRequest => {
  return refreshAccessToken().then(data => {
    localStorage.setItem('access-token', data.access_token);
    localStorage.setItem('refresh-token', data.refresh_token);
    failedRequest.response.config.headers['Authorization'] = 'Bearer ' + data.access_token;
  });
}

/*
const refreshAuthLogic2 = failedRequest => http.post('/v1/user/update-access-token', { refresh_token: window.localStorage.getItem('refresh-token') })
  .then(tokenRefreshResponse => {
    console.log('tokenRefreshResponse');
    localStorage.setItem('access-token', tokenRefreshResponse.data.access_token);
    localStorage.setItem('refresh-token', tokenRefreshResponse.data.refresh_token);
    failedRequest.response.config.headers['Authorization'] = 'Bearer ' + tokenRefreshResponse.data.access_token;
    count = 0;
    return Promise.resolve();
  })
  .catch(error => {
    console.log('error ' + count);
    if (count < 5) {
      count++;
      console.log('refresh');
      //return refreshAuthLogic;
      return Promise.reject();
    }
    //window.location.href = '/logout';
  });
*/

createAuthRefreshInterceptor(http, refreshAuthLogic);

export default http;